var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.74439 1.21183C2.32132 0.788765 1.63539 0.788765 1.21233 1.21183C0.789251 1.63489 0.789251 2.32083 1.21233 2.74389L7.46831 8.99985L1.21239 15.2558C0.789316 15.6788 0.789316 16.3648 1.21239 16.7878C1.63545 17.2109 2.32139 17.2109 2.74445 16.7878L9.00036 10.5319L15.2563 16.7878C15.6793 17.2109 16.3653 17.2109 16.7883 16.7878C17.2114 16.3648 17.2114 15.6788 16.7883 15.2558L10.5324 8.99985L16.7883 2.74389C17.2115 2.32083 17.2115 1.63489 16.7883 1.21183C16.3653 0.788765 15.6794 0.788765 15.2563 1.21183L9.00036 7.4678L2.74439 1.21183Z",
    fill: "#31394D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.c2d7c3743450734f1f003b4f2dc51e25.svg";
export { ForwardRef as ReactComponent };